"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const themes = ["light", "dark", "brand-regular", "brand-dark", "brand-very-dark", "theme-1", "theme-2", "theme-3", "theme-4", "theme-5"];
const generateThemeClassName = (className, theme) => {
  if (!theme || theme === "is-normal-color" || !themes.includes(theme)) {
    return `${className}--default`;
  } else if (theme === "is-inverse-color") {
    return `${className}--brand-very-dark`;
  } else {
    return `${className}--${theme}`;
  }
};
var _default = generateThemeClassName;
exports.default = _default;